import { Field } from '@amore/ui/components/field'
import { FormLayout } from '@amore/ui/components/form-layout'
import { Textarea } from '@amore/ui/components/textarea'
import { useRef, useState } from 'react'
import { usePrototype } from '@/mock/store'
import { DetailSheet } from '@/patterns/dialog'
import { useToast } from '@/shell/toaster'
import { CeremonyFieldLabel } from './editor-fields'

export function CeremonyNotesSheet({ onClose }: { onClose: () => void }) {
  const { data, canEdit, update } = usePrototype()
  const { showToast } = useToast()
  const [notes, setNotes] = useState(data.ceremony.notes)
  const form = useRef<HTMLFormElement>(null)
  return (
    <DetailSheet
      open
      eyebrow="Podklady"
      title="Poznámky k obřadu"
      dirty={canEdit && notes !== data.ceremony.notes}
      onOpenChange={(open) => {
        if (!open) onClose()
      }}
      primaryAction={
        canEdit ? { label: 'Uložit', onClick: () => form.current?.requestSubmit() } : undefined
      }
    >
      <FormLayout
        ref={form}
        onSubmit={(event) => {
          event.preventDefault()
          if (!canEdit) return
          update((current) => ({
            ...current,
            ceremony: { ...current.ceremony, notes: notes.trim() },
          }))
          showToast({ title: 'Poznámky uloženy', tone: 'success' })
          onClose()
        }}
      >
        <Field controlId="ceremony-notes" label={<CeremonyFieldLabel>Poznámky</CeremonyFieldLabel>}>
          <Textarea
            value={notes}
            onChange={(event) => setNotes(event.target.value)}
            readOnly={!canEdit}
            maxLength={5000}
            rows={10}
            className="min-h-56 border-transparent bg-muted/60 hover:bg-muted focus:bg-card"
            placeholder="Vaše přání, nápady a vše důležité k obřadu…"
          />
        </Field>
      </FormLayout>
    </DetailSheet>
  )
}
